import $ from 'domtastic';
import { cookie, events } from '../utils';

class Starred {
  static getAttributes($star) {
    const category = $star.data('category');
    const subcategory = $star.data('subcategory');
    const contacts = $star.data('contacts');
    const title = $star.data('title');
    const url = $star.data('url');
    const slug = $star.data('slug');
    if (!category || !title || !url || !slug) return null;
    const product = { [slug]: { category, subcategory, contacts, title, url, slug, city: cookie.get('city') } };

    return product;
  }

  static getPreviousStarred() {
    const cookieData = cookie.get('starred');
    if (!cookieData) return {};
    return JSON.parse(cookieData) || {};
  }

  static handleStar($star) {
    const product = Starred.getAttributes($star);
    if (!product) return;
    const starState = $star.hasClass('-active');
    let store = Starred.getPreviousStarred();
    store = $star.hasClass('-active') ? Starred.removeFromStore(store, product) : store = Starred.addToStore(store, product);

    const starIconName = $star.data('icon') || 'star';

    Starred.setStarred(store);
    Starred.updateInvokerIcon($star, starState ? 'star-o' : starIconName);
    Starred.onUpdate($star, Object.keys(store).length, starState);
  }

  // only sets the state a star should have (should only be called externally from another class)
  static setStarState($star) {
    const store = Starred.getPreviousStarred();
    const storeLength = Object.keys(store).length;
    const starState = storeLength > 0;
    Starred.onUpdate($star, storeLength, starState);
  }

  static addToStore(store, product) {
    const newStore = store;
    Object.keys(product).forEach((key) => {
      if (!store[key]) newStore[key] = product[key];
    });

    return newStore;
  }

  static removeFromStore(store, product, slug) {
    const newStore = store;
    if (slug) {
      Object.keys(store).forEach((key) => {
        if (key === slug) delete newStore[key];
      });
    } else {
      Object.keys(product).forEach((key) => {
        if (store[key]) delete newStore[key];
      });
    }

    return newStore;
  }

  static setStarred(object) {
    const data = JSON.stringify(object);
    cookie.set('starred', data);
    if (data && data.length > 9) return true;
    return false;
  }

  static updateButton($star, state) {
    return state ? $star.removeClass('-active') : $star.addClass('-active');
  }

  static updateInvokerIcon($star, iconName) {
    const $icon = $star.find('.js-star-invoker-icon');
    if (!$icon[0] || iconName === undefined) return;

    $icon.removeClass('-star-o');
    $icon.removeClass('-star-white');
    $icon.addClass(`-${iconName}`);
    const $use = $icon.find('use');
    if (!$use[0]) return;
    $use.attr('xlink:href', `#${iconName}`);
  }

  static onUpdate($star, length, invokerState) {
    if ($star && invokerState !== undefined) Starred.updateButton($star, invokerState);
    events.emit('starupdate', { $invoker: $star, starredLength: length });
  }

  static handleNavIcon($icon, hasStarred) {
    const iconName = hasStarred ? 'star-white' : 'star-o';
    const $use = $icon.find('use');
    if (!$use[0]) return;
    $use.attr('xlink:href', `#${iconName}`);

    if (hasStarred) {
      $icon.addClass('-active');
    } else {
      $icon.removeClass('-active');
    }
  }

  static updateNavCount($counter, count) {
    $counter.text(count);
  }

  constructor() {
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$invoker = $('.js-star-invoker');
    this.$navIcon = $('.js-star-nav');
    this.$navCount = $('.js-star-nav-count');
  }

  bindEvents() {
    this.$invoker.off().on('click', (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget || event.target);
      Starred.handleStar($target);
    });

    events.on('starupdate', (event) => {
      this.cacheDom();
      const hasStarred = event.starredLength > 0;
      Starred.handleNavIcon(this.$navIcon, hasStarred);
      Starred.updateNavCount(this.$navCount, event.starredLength);
    });

    events.on('contentloaded', () => {
      this.cacheDom();
      this.bindEvents();
    });
  }
}

export default new Starred();
export { Starred };



// WEBPACK FOOTER //
// ./components/Starred.js